export default [
  {
    path: 'createSummoningOrder',
    name: 'CreateSummoningOrder',
    meta: {
      title: '发召集令'
    },
    component: () =>
      import('../views/exerland/SummoningOrder/Create.vue')
  },
  {
    path: 'singUpList/:id',
    name: 'SingUpList',
    meta: {
      title: '报名者'
    },
    component: () =>
      import('../views/exerland/SummoningOrder/SignUpList.vue')
  },
  {
    path: 'summoningOrderDetails/:id',
    name: 'SummoningOrderDetails',
    meta: {
      title: '召集详情'
    },
    component: () =>
      import('../views/exerland/SummoningOrder/details.vue')
  },
  {
    path: 'officialCallingList',
    name: 'OfficialCallingList',
    meta: {
      title: '热门召集令'
    },
    component: () =>
      import('../views/exerland/SummoningOrder/officialCallingList')
  }
]
